import { render, staticRenderFns } from "./GameEnd.vue?vue&type=template&id=04430ed4&"
import script from "./GameEnd.vue?vue&type=script&lang=js&"
export * from "./GameEnd.vue?vue&type=script&lang=js&"
import style0 from "./GameEnd.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports